var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-nav-bar',{attrs:{"title":_vm.title,"left-text":"返回","left-arrow":"","safe-area-inset-top":true},on:{"click-left":_vm.onClickLeft}})
}
var staticRenderFns = []

export { render, staticRenderFns }